/* eslint-disable i18next/no-literal-string */
import { useFormContext } from 'react-hook-form';
import { Box, InputAdornment, MenuItem, Select, type TextFieldProps } from 'ui';

import type { WithRequired } from '../../utils/types';
import { TextField } from '../TextField/TextField';

type Props = WithRequired<TextFieldProps, 'name' | 'label'> & {
  offsetFieldName?: string;
};

export const DueDateOffsetField = ({ name, disabled, offsetFieldName = '', ...rest }: Props) => {
  const form = useFormContext();
  const { setValue } = form;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <TextField
        type="number"
        name={name}
        disabled={disabled}
        sx={{
          width: 'calc(100% - 100px)',
        }}
        {...rest}
        slotProps={{
          input: {
            endAdornment: <InputAdornment position={'end'}>days</InputAdornment>,
          },
        }}
      />
      <Select
        defaultValue="1"
        label=""
        disabled={disabled}
        onChange={(e) => {
          setValue(offsetFieldName, Number(e.target.value));
        }}
        fullWidth={false}
        sx={{
          width: '100px',
        }}
      >
        <MenuItem key="-1" value="-1">
          before
        </MenuItem>
        <MenuItem key="1" value="1">
          after
        </MenuItem>
      </Select>
    </Box>
  );
};
